import { LegalLayout } from "@/components/LegalLayout";

export default function AboutPage() {
  return (
    <LegalLayout title="About Brimi AI" lastUpdated="February 2026" testId="about-page">
      <p>
        <strong>Brimi AI</strong> is an AI-powered learning companion built exclusively
        for <strong>ICSE & ISC</strong> students of Classes IX, X, XI and XII. Our mission
        is simple: make high-quality, personalised tutoring affordable and accessible
        to every Indian student preparing for board exams.
      </p>

      <h2>What we do</h2>
      <ul>
        <li><strong>Chat-based AI tutor</strong> — instant, chapter-aware answers powered by Claude Sonnet 4.5.</li>
        <li><strong>Practice quizzes</strong> — auto-generated MCQs per chapter with explanations.</li>
        <li><strong>Smart notes</strong> — chapter-wise slide decks with audio narration.</li>
        <li><strong>Curriculum-aligned</strong> — built strictly around the ICSE & ISC syllabus for Computer Applications, Computer Science and English.</li>
      </ul>

      <h2>Who we are</h2>
      <p>
        Brimi AI is operated by <strong>Brajesh Chaudhary</strong> as a sole proprietorship
        based in Tundla, Uttar Pradesh. We are an independent edtech operator and are not
        affiliated with CISCE, ICSE, ISC or any school board.
      </p>

      <h2>Business details</h2>
      <ul>
        <li><strong>Owner / Proprietor:</strong> Brajesh Chaudhary</li>
        <li><strong>Address:</strong> 1 MP Road, Tundla, District Firozabad, Uttar Pradesh — 283204, India</li>
        <li><strong>Email:</strong> <a href="mailto:brajeshc56@gmail.com">brajeshc56@gmail.com</a></li>
        <li><strong>Phone:</strong> +91 79836 33563</li>
      </ul>

      <h2>Contact us</h2>
      <p>
        Questions, feedback or partnership ideas? Reach us at{" "}
        <a href="mailto:brajeshc56@gmail.com">brajeshc56@gmail.com</a> or call{" "}
        <strong>+91 79836 33563</strong> on weekdays between 10:00 AM and 6:00 PM IST.
      </p>
    </LegalLayout>
  );
}
